<mat-tab-group (selectedTabChange)="refreshCUIDData()">
    <mat-tab  label="Dashboard">
        <div class="d-flex">
            <section class="col-2">
                <h3>Filter Options</h3>
                    <h3 class="col">
                        Date Range:
                    </h3>
                    <mat-form-field class="col">
                        <mat-label>Enter a date range</mat-label>
                        <mat-date-range-input [rangePicker]="picker">
                            <input matStartDate placeholder="Start date"
                                   [ngModel]="dashBoardDataService?.dashboardFilter?.dateRange?.start"
                                   (ngModelChange)="setDashboardFilterValue('start', $event)">
                            <input matEndDate placeholder="End date"
                                   [ngModel]="dashBoardDataService?.dashboardFilter?.dateRange?.end"
                                   (ngModelChange)="setDashboardFilterValue('end', $event)">
                        </mat-date-range-input>
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-date-range-picker #picker></mat-date-range-picker>
                    </mat-form-field>
                    <h3 class="col">
                        CUID:
                    </h3>
                    <mat-form-field  class=" search-input col" id="dashboard-select">
                        <mat-select [(value)]="cuid" (selectionChange)="setDashboardFilterValue('cuid', cuid)">
                            <mat-option [value]="'None'">
                                None
                            </mat-option>
                            <mat-option *ngFor="let cu of dashBoardDataService.creditUnions | async | orderBy: 'cuid'"
                                        [value]="cu.cuid">
                                {{cu.cuid + ' - ' + cu.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <h3 class="col">
                        Category:
                    </h3>
                    <mat-form-field  class=" search-input col" id="catagory-select">
                        <mat-select [(value)]="selectedCategory"
                                    (selectionChange)="setDashboardFilterValue('cat', selectedCategory)">
                            <mat-option [value]="'All'">
                                All
                            </mat-option>
                            <mat-option *ngFor="let cat of dashBoardDataService.cats | async" [value]="cat">
                                {{cat}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
            </section>
            <section class="col-10">
                <div class="flex-wrap d-flex">
                    <mat-card *ngFor="let cat of dashBoardDataService.downloadDocumentData | async" class="col">
                        <mat-card-header class="bg-blue">
                            <mat-card-title>{{cat.key}}</mat-card-title>
                        </mat-card-header>
                        <mat-card-content>
                            <mat-list>
                            <mat-list-item *ngFor="let info of cat.value">
                                <span class="col-10">{{info.file}}</span> <span class="col-2">{{info.count}}</span>
                            </mat-list-item>
                            </mat-list>
                        </mat-card-content>
                    </mat-card>
                </div>
            </section>
        </div>
    </mat-tab>
    <mat-tab  label="CUID Count" #CUIDTab >
        <div class="d-flex">
            <section class="col-2">
                <h3>Filter Options</h3>
                <mat-list role="list">
                    <h3 class="col">
                        Date Range:
                    </h3>
                    <mat-form-field class="col" (blur)="reloadOnDateChange()">
                        <mat-label>Enter a date range</mat-label>
                        <mat-date-range-input [rangePicker]="pickercuid" >
                            <input matStartDate placeholder="Start date"
                                   [ngModel]="dashBoardDataService?.cuidFilter?.dateRange?.start"
                                   (ngModelChange)="setCUIDFilterValue('start', $event)" (blur)="reloadOnDateChange()">
                            <input matEndDate placeholder="End date"
                                   [ngModel]="dashBoardDataService?.cuidFilter?.dateRange?.end"
                                   (ngModelChange)="setCUIDFilterValue('end', $event)" (blur)="reloadOnDateChange()">
                        </mat-date-range-input>
                        <mat-datepicker-toggle matSuffix [for]="pickercuid"></mat-datepicker-toggle>
                        <mat-date-range-picker #pickercuid (closed)="reloadOnDateChange()"></mat-date-range-picker>
                    </mat-form-field>
                    <h3 class="col">
                        CUID:
                    </h3>
                    <mat-form-field  class="search-input col" id="cuid-select">
                        <mat-select [(value)]="cuid" (selectionChange)="setCUIDFilterValue('cuid', cuid)">
                            <mat-option [value]="'None'">
                                None
                            </mat-option>
                            <mat-option *ngFor="let cu of dashBoardDataService.creditUnions | async | orderBy: 'cuid'"
                                        [value]="cu.cuid">
                                {{cu.cuid + ' - ' + cu.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </mat-list>
            </section>
            <section class="col-10">
                <ng-container *ngIf="dashboardDataSource as dataSource">
                    <table  mat-table
                           [dataSource]="dataSource" matSort class="table"
                            id="CUIDTable">
                        <ng-container [matColumnDef]="column.value" *ngFor="let column of displayedColumns">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{column.label}} </th>
                            <td mat-cell *matCellDef="let element" [ngSwitch]="true">
                                <span *ngSwitchCase="column.value === 'lastSignin'">
                                {{element['lastSignin'] |date: 'M/dd/yyyy'}}
                            </span>
                            <span *ngSwitchCase="column.value === 'username'">
                                {{element['username'] | toName: (allPortalUsers | async)}}
                            </span>
                                <span *ngSwitchCase="column.value === 'cuid'">
                                {{element['cuid'] |toName: (creditUnions | async): 'CreditUnion'}}
                            </span>
                                <span *ngSwitchDefault>{{element[column.value]}}</span>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="columns" class="w-100"></tr>
                        <tr mat-row *matRowDef="let row; columns: columns;" class="w-100"></tr>
                    </table>
                    <mat-paginator [pageSizeOptions]="[10,25,50,100, dataSource.data.length]"></mat-paginator>
                </ng-container>
            </section>
        </div>
    </mat-tab>
</mat-tab-group>
